import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
    selector: 'cap-form-field',
    templateUrl: './form-field.component.html',
    standalone: false
})
export class FormFieldComponent {
  @Input() public control: AbstractControl;
  @Input() public label: string;
}
